import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import JsonBeautifierPage from './JsonBeautifierPage';
import HtmlViewerPage from './HtmlViewerPage';
import HexToPantonePage from './HexToPantonePage';
import BinaryToDecimalPage from './BinaryToDecimalPage';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`developer-tools-tabpanel-${index}`}
      aria-labelledby={`developer-tools-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `developer-tools-tab-${index}`,
    'aria-controls': `developer-tools-tabpanel-${index}`,
  };
}

const tabKeyMap: { [key: string]: number } = {
  'json-beautifier': 0,
  'html-viewer': 1,
  'hex-to-pantone': 2,
  'binary-to-decimal': 3,
};

interface DeveloperToolsPageProps {
  initialTabKey?: string;
}

export default function DeveloperToolsPage({ initialTabKey }: DeveloperToolsPageProps) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (initialTabKey && tabKeyMap[initialTabKey] !== undefined) {
      setValue(tabKeyMap[initialTabKey]);
    }
  }, [initialTabKey]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="developer tools tabs">
          <Tab label="JSON Beautifier" {...a11yProps(0)} />
          <Tab label="HTML Viewer" {...a11yProps(1)} />
          <Tab label="HEX to Pantone" {...a11yProps(2)} />
          <Tab label="Binary to Decimal" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <JsonBeautifierPage />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <HtmlViewerPage />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <HexToPantonePage />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <BinaryToDecimalPage />
      </TabPanel>
    </Box>
  );
}
